import React from "react";
import ChatItem from "./ChatItem";
import { useIntl } from "react-intl";
import { StyledAppScrollbar } from "../../index.styled";
import AppList from "@lib/components/AppComponents/AppList";
import ListEmptyResult from "@lib/components/AppComponents/AppList/ListEmptyResult";
import ChatListSkeleton from "@lib/components/AppComponents/AppSkeleton/ChatListSkeleton";

type ChatListProps = {
  chatListData: any[];
  loading: boolean | undefined;
};

const ChatList: React.FC<ChatListProps> = ({ chatListData, loading }) => {
  const { messages } = useIntl();
  return (
    <StyledAppScrollbar>
      <AppList
        data={chatListData}
        ListEmptyComponent={
          <ListEmptyResult
            content={messages["chatApp.noUserFound"] as string}
            loading={loading}
            placeholder={<ChatListSkeleton />}
          />
        }
        renderItem={(item: any) => <ChatItem key={item.id} item={item} />}
      />
    </StyledAppScrollbar>
  );
};

export default ChatList;
